import axios from 'axios'
//import QS from 'qs'
import store from '@/store/index.js'
import router from '@/router'
import i18n from '@/i18n'
// 环境的切换
axios.defaults.baseURL = process.env.VUE_APP_EVENT_API
axios.defaults.timeout = 300000
axios.defaults.withCredentials = true
// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 每次发送请求之前判断vuex中是否存在token
    // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    let token = localStorage.getItem('Token')
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
    }
    return config
  },
  error => {
    var originalRequest = error.config
    if (
      error.code == 'ECONNABORTED' &&
      error.message.indexOf('timeout') != -1 &&
      !originalRequest._retry
    ) {
      error.response = i18n.t('applytimeout')
    }
    return Promise.error(error)
  }
)

// 响应拦截器
axios.interceptors.response.use(
  response => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (response.status === 200) {
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  // 服务器状态码不是2开头的的情况
  // 这里可以跟你们的后台开发人员协商好统一的错误状态码
  // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
  // 下面列举几个常见的操作，其他需求可自行扩展
  error => {
    if (error.response != undefined) {
      if (error.response.status) {
        switch (error.response.status) {
          // 401: 未登录
          // 未登录则跳转登录页面，并携带当前页面的路径
          // 在登录成功后返回当前页面，这一步需要在登录页操作。
          case 400:
            error.response.data.error = { message: i18n.t('savefailedmsg') }
            break
          case 401:
            localStorage.removeItem('loginuser')
            store.state.base.loginuser = {
              Roles: [],
              password: null,
              userName: null,
              token: null
            }
            router.push({
              path: '/'
            })
            break
          // 403 token过期
          // 登录过期对用户进行提示
          // 清除本地token和清空vuex中token对象
          // 跳转登录页面
          case 403:
            /*
            error.response = store.state.other.neterrormsg
            // 清除token
            localStorage.removeItem('token')
            store.commit('loginSuccess', null)
            // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
            setTimeout(() => {
              router.replace({
                path: '/',
                query: {
                  redirect: router.currentRoute.fullPath
                }
              })
            }, 1000)
            */
            break
          // 404请求不存在
          case 404:
            // error.response = i18n.t('neterrormsg')
            break
          case 500:
            break
          // 其他错误，直接抛出错误提示
          default:
          // error.response = i18n.t('neterrormsg')
        }
        return Promise.reject(error.response)
      }
    } else {
      if (error.message.includes('timeout')) {
        return Promise.reject(i18n.t('applytimeout'))
      } else {
        error.response = i18n.t('serviceerrormsg')
        return Promise.reject(error.response)
      }
    }
  }
)

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  axios.defaults.responseType = 'json'
  axios.defaults.headers.get['X-UI-Language'] =
    i18n.locale == 'en' ? 'en-us' : 'zh-cn'
  axios.defaults.headers.get['Cache-Control'] =
    'no-cache' /***解决IE11存在缓存get请求的问题***/
  if (params != undefined && params != null) {
    params.t = new Date().getTime()
  } else {
    params = { t: new Date().getTime() }
  }

  // params needs to be passed this way!!!
  return axios.get(url, { params })
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  axios.defaults.responseType = 'json'
  axios.defaults.headers.post['X-UI-Language'] =
    i18n.locale == 'en' ? 'en-us' : 'zh-cn'
  return axios.post(url, params)
}
/**
 * delete方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function del(url, params) {
  axios.defaults.responseType = 'json'
  return axios.delete(url, params)
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function postfile(url, params) {
  axios.defaults.responseType = 'json'
  axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
  axios.defaults.headers.post['Accept'] = 'multipart/form-data'
  axios.defaults.headers.post['X-UI-Language'] =
    i18n.locale == 'en' ? 'en-us' : 'zh-cn'
  return axios.post(url, params)
}

export function postdownfile(url, params) {
  axios.defaults.responseType = 'blob'
  axios.defaults.headers.post['X-UI-Language'] =
    i18n.locale == 'en' ? 'en-us' : 'zh-cn'
  return axios.post(url, params)
}
